/**
 * This is a simple Vue.js mixin that signs the user to klaviyo and attentive
 */
import nanoajax from 'nanoajax'
import { serializeToQs } from 'utils/general'
import { formatAsPhoneNumber } from 'utils/general'

const KLAVIYO_SIGNUP_URL = 'https://a.klaviyo.com/ajax/subscriptions/subscribe'

export default {
  methods: {
    // Migration plan
    // email: encodeURIComponent(this.emailValue)
    // listId: this.klaviyoListId
    // sourceId

    /**
     * @author Fernando J. Gomez
     * @param {{
     * listId: String,
     * email: String,
     * $source ?:String,
     * $first_name ?: String,
     * $last_name ?: String,
     * $phone_number ?: String,
     * acceptMarketing: Boolean}} options
     *
     * @returns {Promise<Boolean>}
     * @description Subscribe a user to a claviyo listId. You can add any metadata on the options param as a string  o number to store it.NESTED OBJECTS ARE NOT ALLOWED.
    */
    submitToKlaviyo (options = {}) {
      return new Promise(resolve => {
        if (!options.acceptMarketing || !options.email || !options.listId) {
          resolve(false)
        } else {
          // Payload base body
          let payloadBody = `g=${options.listId}&email=${encodeURIComponent(options.email)}`

          // Clone the options object without the basic/mandatory properties
          const auxAllOptions = {
            ...options,
            listId: undefined,
            email: undefined,
            acceptMarketing: undefined
          }

          // Extra fields map (needed by klaviyo)
          const extraFields = []

          // Get the klaviyo options and adding them
          const klaviyoOptions = {
            $source: auxAllOptions.$source,
            $first_name: auxAllOptions.$first_name,
            $last_name: auxAllOptions.$last_name,
            $phone_number: auxAllOptions.$phone_number
          }
          const klaviyoSerializedOptions = serializeToQs(klaviyoOptions)
          payloadBody += klaviyoSerializedOptions ? `&${klaviyoSerializedOptions}` : ''

          // Adding custom properties
          const extraSerializedOptions = Object.entries(auxAllOptions)
            // Removing undefined values and the ones added in the klaviyo options
            .filter(([key, val]) => typeof val !== 'undefined' && typeof klaviyoOptions[key] === 'undefined')
            // Map the extra values and append it to the extraFields string
            .map(([key, val]) => {
              extraFields.push(key)
              return `${key}=${encodeURIComponent(val)}`
            })
            .join('&')

          payloadBody += extraSerializedOptions ? `&${extraSerializedOptions}&$fields=${extraFields.join(',')}` : ''

          nanoajax.ajax({
            url: KLAVIYO_SIGNUP_URL,
            method: 'post',
            body: payloadBody
          }, (_, rawRes) => {
            const response = JSON.parse(rawRes)
            if (response && response.success) {
              return resolve(true)
            }
            return resolve(false)
          })
        }
      })
    },
    submitToAttentive (creativeId = null) {
      const endpointUrl = '/api/attentive';
      const baseUrlDefault = 'https://fenty-attentive.herokuapp.com';
      const baseUrl = this.baseUrl || baseUrlDefault;
      const countryCode = window.Shopify.country;
      const formattedPhoneNumber = formatAsPhoneNumber(this.phoneValue, countryCode);

      return new Promise(resolve => {
        if (!this.phoneSendSMS) {
          resolve(false)
        } else {
          const attentiveVisitorId = document.cookie.replace(/(?:(?:^|.*;\s*)__attentive_id\s*=\s*([^;]*).*$)|^.*$/, '$1')

          const payload = {
            phone: formattedPhoneNumber,
            visitorId: attentiveVisitorId
          }

          if (creativeId) {
            payload.creativeId = creativeId
          }
          const url = `${baseUrl}${endpointUrl}`
          
          nanoajax.ajax({
            url,
            method: 'post',
            body: serializeToQs(payload)
          }, () => {
            resolve(true)
          })
        }
      })
    }
  }
}
